<template>
    <div class="flex items-center justify-between">
        <span class="flex-grow flex flex-col cursor-default" :id="name" @click="$refs.backingCheckbox.click()">
            <form-label>{{ label }}</form-label>
            <form-help>{{ help }}</form-help>
        </span>
        <span
            @click="$refs.backingCheckbox.click()"
            role="checkbox"
            tabindex="0"
            aria-checked="false"
            :aria-labelledby="name"
            :class="isActive ? activeColor : 'bg-gray-200 dark:bg-gray-600'"
            class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
        >
            <span aria-hidden="true" :class="isActive ? 'translate-x-5' : 'translate-x-0'"
                  class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200 dark:bg-gray-300"></span>
        </span>
        <input ref="backingCheckbox" type="checkbox" class="hidden" v-model="_value" :value="toggleValue">
    </div>
</template>

<script>
import FormLabel from '../Label';
import FormHelp from '../Help';

export default {
    name: 'Toggle',

    components: {FormHelp, FormLabel},

    props: {
        value: {
            type: [Number, Boolean, Array],
        },
        toggleValue: {
            type: String,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
        },
        help: {
            type: String,
        },
        activeColor: {
            type: String,
            default: 'bg-indigo-600',
        },
    },

    computed: {
        _value: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        isActive() {
            if (!Array.isArray(this.value)) {
                return !!this.value;
            }

            return this.value.includes(this.toggleValue);
        }
    },
};
</script>
